module.exports = __webpack_public_path__ + "img/6.7f2d7897.jpg";